import Vue from 'vue'
import { Carousel, CheckboxGroup, Checkbox, Tooltip, Dropdown, Loading, Collapse, CollapseItem, Select, Option, DropdownMenu, DropdownItem, Progress, Upload, Col, Pagination, Table, TableColumn, Radio, Dialog, Form, Button, Input, FormItem, CarouselItem, Message, Menu, MenuItem, MenuItemGroup, Submenu, MessageBox, InfiniteScroll, Breadcrumb, BreadcrumbItem, DatePicker } from 'element-ui'
Vue.use(Carousel)
Vue.use(CarouselItem)
Vue.use(Menu)
Vue.use(MenuItem)
Vue.use(MenuItemGroup)
Vue.use(Submenu)
Vue.use(InfiniteScroll)
Vue.use(Breadcrumb)
Vue.use(DatePicker)
Vue.use(BreadcrumbItem)
Vue.use(Dialog)
Vue.use(Form)
Vue.use(Input)
Vue.use(FormItem)
Vue.use(Button)
Vue.use(Col)
Vue.use(Radio)
Vue.use(Table)
Vue.use(Pagination)
Vue.use(TableColumn)
Vue.use(Progress)
Vue.use(Upload)
Vue.use(Dropdown)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.use(Select)
Vue.use(Option)
Vue.use(Collapse)
Vue.use(CollapseItem)
Vue.use(Tooltip)
Vue.use(Loading)
Vue.use(CheckboxGroup)
Vue.use(Checkbox)
Vue.prototype.$message = Message
Vue.prototype.$alert = MessageBox.alert
Vue.prototype.$confirm = MessageBox.confirm
